import React, { useEffect, useRef, useState } from 'react';
import queryString from 'query-string';
import { CSSTransition } from 'react-transition-group';
import { Alert, Form, Progress } from 'reactstrap';

import { useLocalization, WithLocalize } from '../../containers/I18nProvider';
import { WithCaptcha } from '../../containers/captcha';

import vallevisionLogo from './img/vallevision-logo.png';

const LoginForm = ({ api, location, TurnstileComponent, ...props }) => {
  const nodeRef = useRef(null);
  const { translate } = useLocalization();
  const [onLogin, setOnLogin] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [error, setError] = useState({
    open: false,
    message: '',
  });
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  const parameters = queryString.parse(location.search);

  useEffect(() => {
    setShowForm(true);
  }, []);

  const onSubmit = async (ev) => {
    ev.preventDefault();
    setOnLogin(true);
    setError({
      open: false,
      message: '',
    });

    api.userPassLogin(
      {
        username,
        password,
        cp_convert: parameters.cp_convert,
      },
      parameters
    )
      .then((response) => {
        setOnLogin(false);
        window.location = `${parameters.redirect_uri}?${queryString.stringify(response)}`;
      })
      .catch((apiError) => {
        const translatedError = translate(apiError.errorCode);
        let message = translate('RequestLoginErrorMessage');

        if (translatedError) {
          message = translatedError;
        } else if (apiError.details) {
          message = apiError.details;
        }

        setOnLogin(false);
        setError({ open: true, message });
      });
  };

  return (
    <CSSTransition
      in={showForm}
      timeout={300}
      classNames="formshow"
      nodeRef={nodeRef}
      unmountOnExit
    >
      <Form onSubmit={(event) => onSubmit(event)} className="login-vallevision">
        <div className="wrapper-vallevision fadeInDown" ref={nodeRef}>
          <div id="formContent-vallevision">
            <div className="menu1-vallevision">
              <div className="vallevision-brand">
                <img src={vallevisionLogo} alt="Vallevisión" className="vallevision-brand-main" />
              </div>

              <p className="title-vallevision">{translate('Title')}</p>
              <p className="subtitle-vallevision">{translate('Subtitle')}</p>

              <input
                className="fadeIn second"
                disabled={onLogin}
                onChange={(e) => setUsername(e.target.value)}
                required={true}
                tabIndex={1}
                type="text"
                autoCorrect="off"
                autoCapitalize="none"
                name="login"
                id="login-vallevision"
                placeholder={translate('PlaceholderUserName')}
              />

              <input
                className="fadeIn third"
                required={true}
                disabled={onLogin}
                onChange={(e) => setPassword(e.target.value)}
                tabIndex={2}
                type="password"
                autoCorrect="off"
                autoCapitalize="none"
                id="password-vallevision"
                name="password"
                placeholder={translate('PlaceholderPassword')}
              />

              <div className="buttons-vallevision">
                {!onLogin ? (
                  <button
                    type="submit"
                    className="fadeIn fourth"
                    id="entrar-vallevision"
                    disabled={!props.turnstileSuccess}
                  >
                    <span className="entrar-text">{translate('ButtonEnter')}</span>
                  </button>
                ) : (
                  <Progress animated color="danger" value={100} />
                )}
              </div>

              <TurnstileComponent setTurnstileSuccess={props.setTurnstileSuccess} />

              <div className="messages-container">
                <Alert
                  color="danger"
                  id="error-message"
                  isOpen={error.open}
                  toggle={() => setError({ open: false })}
                >
                  {error.message}
                </Alert>
              </div>
            </div>
          </div>
        </div>
      </Form>
    </CSSTransition>
  );
};

export default WithCaptcha(WithLocalize(LoginForm), {
  useInsideForm: true,
  style: { marginTop: '1.25rem' },
});
